import {useContext} from "react";
import APIData from "../context/APIData";


export const useAPIData = () => {
    const context = useContext(APIData)
    if (context === undefined) {
        throw new Error('useAPIData should only be used inside APIDataProvider')
    }
    return context
}